import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/cms/popular-destinations', request)
}

export {get}
